import axios from "axios";

export default async function deactivateAdminUser(userName) {
    const res = await axios.patch(`/admin-dashboard/user/${userName}/deactivate`)
}